import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Asset } from '@app/core/model/entities/asset/asset';
import { Work } from '@app/core/model/entities/works/work';
import { WorksService } from '@app/features/main/views/works/works.service';
import { defer, iif, Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, first, map, switchMap, tap } from 'rxjs/operators';

export const canChangeWorkAsset = (workService: WorksService, workToCheck: Work): AsyncValidatorFn => {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {

    if (control.pristine || !(workToCheck instanceof Work)) {
      return of(null);
    }

    return control.valueChanges.pipe(
      debounceTime(250),
      distinctUntilChanged(),
      switchMap((newAsset: Asset | null) => {
        return iif(
          // If asset is not null, execute async validation, otherwise only return an error if the work has projects
          () => !!newAsset,
          defer(() => workService.canChangeWorkAsset(workToCheck.id, newAsset.id)
            .pipe(map((error) => !!error ? {canChangeWorkAsset: true} : null))),
          defer(() => of(workToCheck.projectIds.length > 0 ? {canChangeWorkAsset: true} : null))
        );
      }),
      first(),
      tap(() => control.markAsTouched())
    );
  };
};
